<template>
  <!-- Contenido del título e introducción -->
  <section class="wmax intro hiddenxs" style="margin-top: 5vh">
    <div class="row">
      <div class="col col-xs-12 col-7">
        <!--<h2   data-aos="fade-zoom-in" data-aos-easing="ease-in-sine"  data-aos-duration="5000">Murcia <span >Barroca</span></h2>-->
        <img class="logo" src="@/assets/img/logo.svg" />

        <p style="width: 100%">
          El arte barroco dejó una huella imborrable en nuestra ciudad durante los siglos XVII y XVIII. El Ayuntamiento de
          Murcia con este proyecto “Murcia Barroca”, pretende poner en valor nuestro
          rico patrimonio cultural y artístico. Por iniciativa municipal, la Ciudad de Murcia lidera la creación de Red de
          Ciudades Barrocas de España, junto a ciudades como Madrid, Valencia, Sevilla,
          Valladolid o Toledo; lo que propiciará encuentros y programación de manera conjunta.
        </p>

        <p style="width: 100%">
          Este periodo se caracterizó por una explosión de creatividad y esplendor artístico, esto unido a la bonanza
          económica hizo que la ciudad transformara radicalmente su apariencia. La
          arquitectura barroca se convirtió en el lenguaje visual dominante, con iglesias, palacios y edificios públicos
          ricamente decorados. La Catedral de Murcia, uno de los principales exponentes
          de este estilo, impresiona con su fachada principal ricamente ornamentada y su espléndido interior. Otro
          magnífico ejemplo es el Palacio Episcopal, con su portada elaborada y sus detalles
          exquisitos.
        </p>

        <p style="width: 100%">
          La escultura también jugó un papel fundamental en el arte barroco murciano. Los escultores locales destacaron
          por su habilidad para plasmar la emotividad y el realismo en sus obras. El
          escultor Francisco Salzillo, es una muestra impresionante de esta destreza artística que se desarrolló en
          nuestra ciudad. Las tallas detalladas y expresivas, junto con la cuidadosa
          iluminación y rica ornamentación floral, hacen de la Semana Santa de Murcia una experiencia única e inolvidable.
        </p>

        <p style="width: 100%">
          Además de la arquitectura y la escultura, la pintura también floreció en este periodo. Los artistas murcianos
          desarrollaron un estilo propio que combinaba elementos del barroco italiano con
          influencias locales. Los cuadros religiosos eran especialmente populares y se caracterizaban por su dramatismo y
          uso hábil del color y la luz.
        </p>

        <p style="width: 100%">
          En resumen, el arte barroco del siglo XVII y XVIII en Murcia supuso una época de esplendor artístico, con
          magníficas obras arquitectónicas, escultóricas y pictóricas que aún hoy embellecen
          la ciudad. Estas creaciones reflejan la pasión, la emotividad y la maestría técnica de los artistas murcianos,
          dejando un legado duradero que nos permite apreciar y admirar su talento hasta
          el día de hoy.
        </p>

        <p style="width: 100%">
          Es por eso que te invitamos a disfrutar de ese legado barroco, a recorrer sus calles y plazas y a escuchar su
          música y conocer como creció la ciudad, se convirtió en un gran referente
          cultural de la época.
        </p>
        <p><strong>¡Descubre los secretos de Murcia Barroca!</strong></p>
      </div>

      <div class="col col-xs-12 col-4">
        <div class="data_video_imagen text-center">
          <!--<img src="@/assets/img/banner_home.jpg" width="100%" style="width: 100%; margin: 0 auto; margin-top: 20px" />-->
          <div v-html="ContentHtml.valor"></div>
        </div>
        <div class="text-center" style="margin-top: 20px; background-color: #f4f1e7; text-align: center !important">
          <v-calendar :attributes="attrs" @dayclick="onDayClick" expanded />
        </div>
      </div>
    </div>
  </section>

  <!-- Contenido del título e introducción -->
  <section class="wmax intro showxs">
    <div class="row">
      <div class="col col-12">
        <img src="@/assets/img/logo.svg" class="logo" width="100%" />
        <p style="max-width: 100%">
          El arte barroco del siglo XVII y XVIII en Murcia supuso una época de esplendor artístico, con magníficas obras
          arquitectónicas, escultóricas y pictóricas que aún hoy embellecen la ciudad.
          Estas creaciones reflejan la pasión, la emotividad y la maestría técnica de los artistas murcianos, dejando un
          legado duradero que nos permite apreciar y admirar su talento hasta el día de
          hoy.
        </p>
        <p>
          Es por eso que te invitamos a disfrutar de ese legado barroco, a recorrer sus calles y plazas y a escuchar su
          música y conocer como creció la cuidad, se convirtió en un gran referente
          cultural de la época. <strong>¡Descubre los secretos de Murcia Barroca!</strong>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      actividades: [],
      loading: true,
      totalActividades: 0,
      actividadesPorDia: {},
      ContentHtml: [],
      attrs: [
        {
          key: "today",
          highlight: "red",
          dot: "red",
          order: 3,
          contentStyle: {
            color: "#fafafa", // Color del texto del día actual
            backgroundColor: "#8b2119", // Color de fondo del día actual
          },
          dates: new Date(),
        },
        {
          key: "event",
          dot: "transparent",
          dates: [new Date(2023, 10, 11), new Date(2023, 10, 10), new Date(2023, 10, 17)],
          contentStyle: {
            color: "#fafafa", // Color del texto de los días del evento
          },
          highlight: {
            color: "red",
            fillMode: "light",
          },
        },
      ],
    };
  },
  created() {
    this.loadLugares();
    this.loadVideoImagen();
  },

  methods: {
    loadVideoImagen() {
      axios
        .get(`https://murciabarroca.es/api/getCustomHtml/1/`)
        .then((response) => {
          this.ContentHtml = response.data.data;
          console.log(this.ContentHtml)
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        })
        .finally(() => { });
    },
    loadLugares() {
      axios
        .get(`https://murciabarroca.es/api/getActividades`)
        .then((response) => {
          this.actividades = response.data.data;
          this.totalActividades = this.actividades.length;
          console.log(this.actividades);

          // Asumiendo que cada actividad tiene una propiedad 'fecha' en formato 'YYYY-MM-DD'
          const fechasDeActividades = this.actividades.map((actividad) => new Date(actividad.fecha));

          // Agrupar las actividades por día
          this.actividadesPorDia = this.actividades.reduce((acc, actividad) => {
            const fecha = actividad.fecha; // Asumiendo que 'fecha' es una cadena en formato 'YYYY-MM-DD'
            if (!acc[fecha]) {
              acc[fecha] = [];
            }
            acc[fecha].push(actividad);
            return acc;
          }, {});

          // Encuentra el objeto 'event' en attrs y reemplaza su propiedad 'dates'
          const eventAttr = this.attrs.find((attr) => attr.key === "event");
          if (eventAttr) {
            eventAttr.dates = fechasDeActividades;
          }
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDayClick(dateObj) {
      // Evita que el calendario muestre un popup
      event.preventDefault();

      // Extrae el objeto Date del objeto date
      const date = dateObj.date;

      // Formatea la fecha al formato 'YYYY-MM-DD'
      const fecha = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

      // Redirige a la página de Actividades con la fecha como parámetro en la URL
      window.location.href = `/actividades?fecha=${fecha}`;
    },
  },
};
</script>
